import clsx from 'clsx'
import useTranslation from 'next-translate/useTranslation'

function BestsellersBadge({ className }: BestsellersBadgeProps) {
  const { t } = useTranslation('global')

  return (
    <div
      className={clsx(
        'flex items-center justify-center bg-green-60 rounded-md max-w-[200px] px-4 py-2',
        className
      )}
    >
      <p className="font-semibold text-md text-sbtgray-100">
        {t('badge_bestseller')}
      </p>
    </div>
  )
}

interface BestsellersBadgeProps {
  className?: string
}

export default BestsellersBadge
